import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TourGuideService } from '../tour-guide.service';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css'],
})
export class HelpComponent implements OnInit {
  constructor(
    private router: Router,
    private tourGuideService: TourGuideService,
    private appComp: AppComponent
  ) {}
  guides = this.tourGuideService.pageList;
  resultMenuList: any = [];
  showModal: boolean = true;

  ngOnInit(): void {
    this.guides = this.tourGuideService.getPageList();
  }
  
  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  onIconClick(guide) {
    this.closeModal();
    if (guide.tourName == 'all') {
      this.tourGuideService.restartTour();
    } else {
      localStorage.setItem(`is${guide.tourName}TourDone`, 'false');
      this.router.navigate([`.${guide.tourPath}`]);
    }
  }
}
